import { apiRequest } from './client'

export type CityOptionDto = { code: string; label: string }

/** Справочник городов для регистрации (публичный, без авторизации). */
export const listCities = () =>
  apiRequest<CityOptionDto[]>('/reference/cities', { auth: false })
